export default function Footer() {
  return (
    <footer className="w-full bg-[#1a2535] text-white">
      <div className="max-w-5xl mx-auto px-6 py-8 flex flex-col md:flex-row items-center md:items-start gap-6">
        {/* Footer Logo */}
        <div className="flex-shrink-0 flex items-center justify-center md:justify-start">
          <img
            src="/images/f-logo.png"
            alt="益維企業有限公司"
            className="h-16 w-auto object-contain"
          />
        </div>

        {/* Footer Info */}
        <div className="flex-1 text-sm text-gray-300 leading-relaxed text-center md:text-left">
          <div className="mb-2">
            <span className="font-semibold text-white">TEL：</span>
            <a href="tel:+886-2-2651-6999" className="hover:text-[#4fc3f7] transition-colors">+886-2-2651-6999</a>
            <span className="mx-2 text-gray-500">│</span>
            <span className="font-semibold text-white">FAX：</span>+886-2-2653-0383
          </div>
          <div className="mb-3">
            <span className="font-semibold text-white">ADDRESS：</span>
            台北市南港區南港路三段99號9樓
            <span className="mx-2 text-gray-500">│</span>
            9F, No.99, Sec.3, Nankang Road, Taipei, Taiwan, R.O.C.
          </div>
          <div className="text-xs text-gray-500 border-t border-gray-700 pt-3">
            COPYRIGHT &copy; 2024 益維 ENTERPRISE CO., LTD. ALL RIGHTS RESERVED.
          </div>
        </div>
      </div>
    </footer>
  );
}
